

import ChartTooltip from "components/chartTooltip"
import { format, select } from "d3"
import useReactTooltipsOnD3 from "hooks/useReactTooltipsOnD3"
import React, { useEffect, useState } from "react"
import { LineChartDataType } from "./types"



export const LineChartToolTips = ({svgRef}) =>{

    const [itemSelector,setItemSelector] = useState<()=>
    d3.Selection<d3.BaseType,LineChartDataType,d3.BaseType,unknown>>()
    useEffect(()=>{
        setItemSelector(()=>()=>{
            return select(svgRef.current)
                .select('.pointGroup')
                .selectAll('.points')
                .selectAll('.point') as any // it is the correct type but the data isn't added here so ts is grumpy
        })
    },[svgRef])

    const toolTipMaker = (d:LineChartDataType) => {
        // Make precise numbers less unwieldy 
        const digitFormatter = format(".4")

        if(typeof d.x === "number") d.x = digitFormatter(d.x)
        if(typeof d.y === "number") d.y = digitFormatter(d.y)

        return <ChartTooltip
            title={d.label || "Point"}
            content={{
                X:d.x,
                Y:d.y
            }}/>
    }

    const toolTipOptions = {
		placement: 'top',
		 modifiers: [
			{
				name: 'offset',
				options: {
					offset: [0, 3],
				},
			},
		], 
	} 


    return useReactTooltipsOnD3(
        itemSelector,
        toolTipMaker,
        toolTipOptions
    )
}